import { createSelector } from 'reselect';
import studentSelector from './student';

export default createSelector(
    studentSelector,
    (student) =>
        student?.curriculumId && ![34, 35, 36, 37, 39, 40, 41, 43].includes(student.curriculumId),
);
